import { useState, useEffect } from 'react'
import axios from 'axios'
import { Modal } from 'antd'
import AuditAlumniEventRegistration from './audit'
import AlumniCertificationDetail from '../certification/detail'

const AlumniEventRegistrationDetail = (props) => {
  const merchantOid = localStorage.getItem('merchant_oid')
  const [registrationDetail, setRegistrationDetail] = useState({})
  const [propsData, setPropsData] = useState({})
  const [isAuditVisible, setIsAuditVisible] = useState(false)
  const [isAlumniVisible, setIsAlumniVisible] = useState(false)

  const getAlumniEventRegistrationDetail = () => {
    axios.post('/p/alumni/event/registration/detail/get', {
      merchant_oid: merchantOid,
      registration_oid: props.data.oid
    })
      .then(function (response) {
        if (response.errcode === 0) {
          setRegistrationDetail(response.data)
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }

  useEffect(() => {
    getAlumniEventRegistrationDetail()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [merchantOid, props.data.oid])

  const handleCancel = () => {
    props.isCancel()
  }

  const getColor = () => {
    if (registrationDetail.status.key === 2) return 'green'
    if (registrationDetail.status.key === 3) return 'red'
    return 'black'
  }

  const openAudit = () => {
    setIsAuditVisible(true)
    setPropsData({ 
      oid: registrationDetail.oid,
      status: registrationDetail.status.key,
      failureReason: registrationDetail.failure_reason
    })
  }

  const openAlumni = () => {
    setIsAlumniVisible(true)
    setPropsData({ 
      oid: registrationDetail.alumni_oid
    })
  }

  return (
    <Modal 
      title="详情"
      destroyOnClose={true}
      width='700px'
      open={props.isOpen}
      onCancel={handleCancel}
      footer={false}>
      
      <div className='public-datail-container'>
        <div className='public-datail-item'>
          <div className='public-datail-label'>报名时间</div>
          <div className='public-datail-content'>{registrationDetail.create_time}</div>
        </div>
        <div className='public-datail-item'>
          <div className='public-datail-label'>报名活动</div>
          <div className='public-datail-content'>{registrationDetail.event_title}</div>
        </div>
        <div className='public-datail-item'>
          <div className='public-datail-label'>报名人姓名</div>
          <div className='public-datail-status'>{registrationDetail.alumni_name}</div>
          <div className='public-datail-button3' onClick={openAlumni}>查看校友详情</div>
        </div>

        {registrationDetail.answers && Object.entries(registrationDetail.answers).map(([key, value], index) => (
          <div className='public-datail-item' key={index}>
            <div className='public-datail-label'>{key}</div>

            <div className='public-datail-content'>
              {Array.isArray(value) && value.length > 0 ? (
                value.join(' ｜ ')
              ) : typeof value === 'string' && value.startsWith('https://oss.yunzhaosoft.com') ? (
                <img
                  src={value}
                  alt={key}
                  style={{ maxWidth: '200px', border: '1px solid #eee' }}
                />
              ) : (
                value
              )}
            </div>
          </div>
        ))}

        {registrationDetail.status && 
          <div className='public-datail-item'>
            <div className='public-datail-label'>审核状态</div>
            <div style={{ color: getColor() }} className='public-datail-status'>{registrationDetail.status.value}</div>
            <div className='public-datail-button' onClick={openAudit}>审核</div>
          </div>
        }
        {(registrationDetail.status && registrationDetail.status.key === 3) &&
          <div className='public-datail-item'>
            <div className='public-datail-label'>拒绝原因</div>
            <div className='public-datail-content'>{registrationDetail.failure_reason || '未填写'}</div>
          </div>
        }
      </div>

      {isAuditVisible && <AuditAlumniEventRegistration
        data={propsData}
        getAlumniEventRegistrationDetail={getAlumniEventRegistrationDetail}
        getAlumniEventRegistrationData={() => { props.getAlumniEventRegistrationData() }}
        isOpen={isAuditVisible}
        isCancel={() => { setIsAuditVisible(false) }}
      />}
      {isAlumniVisible && <AlumniCertificationDetail
        data={propsData}
        isOpen={isAlumniVisible}
        isCancel={() => { setIsAlumniVisible(false) }}
        showAudit={false}
      />}
    </Modal>
  )
}

export default AlumniEventRegistrationDetail
